{
  "ACTIONS": {
    "CONFIRM": "Επιβεβαίωση",
    "CONTINUE": "Συνέχεια",
    "SUBMIT": "Υποβολή",
    "RETRY": "Δοκιμάστε ξανά",
    "CANCEL": "Ακύρωση",
    "EMPTY": "Δεν έχετε παραγγελίες",
    "LOADING_ORDERS": "Προετοιμασία του λογαριασμού σας",
    "CLEAR_ALL": "Clear All",
    "AWESOME": "Awesome!",
    "VIEW_RECEIPT": "The Receipt",
    "ADD_CART": "Add to Cart",
    "UPDATE_CART": "Ενημέρωση καλαθιού",
    "EDIT": "Επεξεργασία",
    "SEARCH_PLACEHOLDER": "Search for food or restaurants"
  },
  "COMMON": {
    "CALORIES": "Cal. {{calories}}",
    "MISSING_SELECTIONS": "Some options are missing, please select before proceeding",
    "ITEM_UNAVAILABLE": "This item is currently not available",
    "SECTION_NOT_FOUND": "Αυτή η ενότητα δεν είναι πλέον διαθέσιμη",
    "ITEM_NOT_FOUND": "Αυτό το αντικείμενο δεν είναι πλέον διαθέσιμο",
    "PROMOTION_NOT_AVAILABLE": "Αυτή η προσφορά δεν είναι πλέον διαθέσιμη",
    "REQUIRED": "Required",
    "COMBO": "Combo",
    "INVALID_EMAIL": "Παρακαλούμε εισαγάγετε έγκυρη διεύθυνση email",
    "INVALID_PHONE": "Παρακαλούμε εισαγάγετε έγκυρο αριθμό τηλεφώνου",
    "FEES": "Fees",
    "MIN_ORDER_ERROR": "Minimum order value of {{currency}} {{amount}} is required to place your order",
    "ADD_MIN_ORDER": "Add {{currency}} {{amount}} to place your order",
    "CONNECTION_ERROR": "Κάτι πήγε στραβά κατά τη φόρτωση αυτού του τραπεζιού. Δοκιμάστε ξανά.",
    "TABLE_NOT_FOUND": "Δεν βρήκαμε αυτό το τραπέζι. Σαρώστε ξανά τον κωδικό QR."
  },
  "LANGUAGES": {
    "EN": "English",
    "AR": "عربي",
    "FA": "فارسي",
    "HI": "हिन्दी",
    "RU": "русский",
    "DE": "Deutsch",
    "FR": "Français",
    "TH": "ไทย",
    "EL": "Ελληνικά",
    "CNR": "Crnogorski",
    "ZH-HANS": "中文",
    "RO": "Română",
    "HU": "Magyar",
    "BG": "български",
    "TR": "Türkçe",
    "ES": "Español"
  },
  "BILL": {
    "NAME": "Επώνυμο",
    "ROOM_NUMBER": "Αριθμός Δωματίου",
    "SNACKBAR_TITLE": "Ο λογαριασμός σας είναι έτοιμος",
    "PAY_BILL": "Πληρωμή"
  },
  "PAY_AT_TABLE": {
    "TOTAL_PEOPLE": "Σύνολο ατόμων στο τραπέζι",
    "PAYING_FOR": "Σύνολο ατόμων για τα οποία πληρώνετε",
    "REMAINING": "Υπολειπόμενο ποσό",
    "CHEQUE": "Λογαριασμός",
    "AMOUNT_PAID": "Ποσό που πληρώθηκε",
    "DISCOUNT": "Έκπτωση",
    "PROMO": "Προσφορά",
    "FEES": "Χρεώσεις",
    "PAID_ITEMS": "Πληρωμένα αντικείμενα",
    "SPLIT_BILL": "Μοιρασμός λογαριασμού",
    "EDIT_SPLIT": "Επεξεργασία μοιρασμού",
    "PAY_BILL": "Πληρωμή λογαριασμού",
    "SPLIT_TITLE": "Μοιράστε τον λογαριασμό",
    "SPLIT_SUBTITLE": "Επιλέξτε πώς θέλετε να μοιράσετε τον λογαριασμό",
    "SPLIT_EVENLY": "Ίσο μοίρασμα",
    "CUSTOM_AMOUNT": "Προσαρμοσμένο ποσό",
    "ADD_CUSTOM_AMOUNT": "Προσθήκη προσαρμοσμένου ποσού",
    "CUSTOM_AMOUNT_PLACEHOLDER": "Εισαγάγετε προσαρμοσμένο ποσό",
    "PAY_FOR_ITEMS": "Πληρώστε τα αντικείμενά σας",
    "CONFIRM_SELECTION": "Επιβεβαίωση επιλογής",
    "SOMEONE_ELSE_PAYING": "Κάποιος άλλος στο τραπέζι σας πληρώνει αυτή τη στιγμή"
  },
  "COMBO": {
    "ADD_N": "Προσθήκη {{count}} {{section}}",
    "REMOVE_N": "Αφαίρεση {{count}} {{section}}",
    "CANNOT_PROCEED": "Ακολουθήστε τον οδηγό παραπάνω για να ολοκληρώσετε το combo σας πριν συνεχίσετε",
    "COMPLETE": "Το combo {{combo}} ολοκληρώθηκε!",
    "ON_ANOTHER_SECTION": "Αυτό είναι μέρος του combo {{section}}"
  },
  "CART": {
    "TITLE": "Καλάθι",
    "RECOMMENDATION": "Μπορεί επίσης να σας αρέσει",
    "TOTAL": "Σύνολο",
    "VIEW": "Προβολή καλαθιού",
    "EMPTY": "Άδειο",
    "PLACE_ORDER": "Τοποθετήστε την παραγγελία",
    "ADD_TO_BILL": "Προσθήκη στον λογαριασμό",
    "PAY_NOW": "Πληρωμή τώρα",
    "OOPS": "Ωχ",
    "ADD_NEW_VARIANT": "Προσθήκη ακόμη ενός",
    "VARIANT_TITLE": "Αλλάξατε γνώμη;",
    "ITEM_UPDATED": "An item in your cart has been updated",
    "ITEM_REMOVED": "An item was removed from your cart because it's no longer available",
    "ITEM_LINE": "{{name}}",
    "CONFIRM_CLEAR": "Are you sure you want to clear the cart?",
    "CLEAR": "Clear Cart",
    "ADD_NOTE": "ADD A NOTE",
    "NOTE_LABEL": "Note"
  },
  "PAYMENT": {
    "CONFIRMED": "Your order has been paid !",
    "ERROR": "An error occurred during payment, please try again",
    "APPLE_PAY_TAP_AGAIN": "Please tap Apple Pay again to continue",
    "TITLE": "Πληρωμή",
    "PAY_CARD": "Checkout",
    "SUCCESSFUL": "Payment Was Successful",
    "SUMMARY": "Payment Summary",
    "PROGRESS": "Payment in progress..., please wait",
    "CANCEL": "Please do not refresh this page or click on the back button. If you wish to cancel, please press the cancel button on the payment machine."
  },
  "ORDER": {
    "TITLE": "Παραγγελίες",
    "CONFIRMED": "Confirmed",
    "NOTES": "Order Notes",
    "TOTAL": "Σύνολο",
    "SUBTOTAL": "Subtotal",
    "ORDER": "Παραγγελία",
    "PAID": "Paid",
    "PLACED": "Your Order Has Been Placed",
    "UNPAID": "Η παραγγελία σας δεν έχει πληρωθεί",
    "CANCELLED": "Η παραγγελία σας ακυρώθηκε",
    "VOID": "Η παραγγελία σας ακυρώθηκε από το κατάστημα",
    "UPDATED": "Η παραγγελία σας ενημερώθηκε",
    "ORDERS": "Orders",
    "PREVIOUS": "Previous Orders",
    "REJECTED": "Oops! One or more items or modifiers are currently unavailable and have been removed from your cart."
  },
  "WAITER": {
    "SNACKBAR_TITLE": "Θα είμαστε μαζί σας σύντομα",
    "HELP": "Πώς μπορούμε να βοηθήσουμε;",
    "ADDITIONAL_COMMENTS": "Comments"
  },
  "MENU": {
    "SKIP": "Παράλειψη",
    "MENU": "Μενού",
    "SEARCH": "Αναζήτηση",
    "NO_SEARCH_RESULTS": "Δεν βρέθηκαν προϊόντα που να ταιριάζουν με την αναζήτησή σας",
    "SEARCH_OTHER_SECTIONS": "Βρήκαμε αντιστοιχίες σε άλλες ενότητες",
    "NO_FILTER_RESULTS": "Δεν βρέθηκαν προϊόντα που να ταιριάζουν με τα φίλτρα σας",
    "CLEAR_FILTERS": "Καθαρισμός φίλτρων",
    "NO_SECTIONS": "Δεν υπάρχουν διαθέσιμες ενότητες",
    "STAFF": "Καλέστε το προσωπικό",
    "FILTERS": "Dietery Filters"
  },
  "SETTINGS": {
    "TITLE": "Ρυθμίσεις",
    "LANGUAGE": "Γλώσσα",
    "SELECT_LANGUAGE": "Επιλέξτε γλώσσα",
    "CURRENCY": "Currency"
  },
  "HOTEL_PREFERENCE": {
    "ROOM": "Δωμάτιοpay"
  },
  "RESCAN": {
    "TITLE": "QR",
    "ACTION": "Please rescan the QR to continue your session",
    "SESSION_EXPIRED": "Your session has expired"
  },
  "PICKUP": {
    "TITLE": "Your Details"
  },
  "VOUCHER": {
    "ADD": "Add a Voucher",
    "PLACEHOLDER": "Εισαγάγετε το voucher σας",
    "VOUCHER": "Voucher",
    "DISCOUNTED_AMOUNT": "Total After Discount",
    "CURRENT_BALANCE": "Balance",
    "REMAINING_BALANCE": "Balance After Purchase",
    "AMOUNT_DUE": "Amount Due"
  },
  "TIP": {
    "TIP": "Φιλοδώρημα",
    "ADD": "Προσθήκη φιλοδωρήματος",
    "PLACEHOLDER": "Εισαγάγετε ποσό φιλοδωρήματος"
  },
  "LANDING": {
    "CALL_WAITER": "Κλήση σερβιτόρου",
    "VIEW_BILL": "Προβολή λογαριασμού - ",
    "LOADING_BILL": "Φόρτωση λογαριασμού"
  },
  "LOADER": {
    "Heading": "Επεξεργασία της πληρωμής σας...",
    "Subheading": "Παρακαλούμε μην κλείσετε αυτή τη σελίδα. Επιβεβαιώνουμε την πληρωμή σας και θα σας ανακατευθύνουμε αυτόματα.",
    "Hint": "Αυτό συνήθως διαρκεί λίγα δευτερόλεπτα."
  },
  "NoVoucher": "Το voucher δεν είναι διαθέσιμο",
  "VoucherDisabled": "Αυτό το voucher είναι απενεργοποιημένο",
  "VoucherExpired": "Αυτό το voucher έχει λήξει",
  "VoucherAlreadyUsed": "Αυτό το voucher έχει ήδη χρησιμοποιηθεί",
  "VoucherZeroBalance": "Αυτό το voucher έχει υπόλοιπο 0",
  "VoucherUserLimitReached": "Έχετε ήδη χρησιμοποιήσει αυτό το voucher",
  "VoucherFirstOrderOnly": "Αυτό το voucher ισχύει μόνο για την πρώτη σας παραγγελία",
  "VoucherNotApplicable": "Αυτό το voucher δεν ισχύει για τα προϊόντα της παραγγελίας σας"
}
